import React from "react";
import { Search, SlidersHorizontal } from "lucide-react";

const EmploymentFilters = ({
  filters = {},
  filterOptions = {},
  onChange,
  onOpenDrawer,
}) => {
  const handleSearchChange = (event) => {
    if (typeof onChange === "function") {
      onChange({
        search: event.target.value,
      });
    }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        {/* SEARCH BAR */}
        <div className="relative flex-1">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3.5">
            <Search className="h-4.5 w-4.5 text-slate-400" />
          </div>
          <input
            type="text"
            value={filters.search || ""}
            onChange={handleSearchChange}
            placeholder="Search employees by name, designation, email..."
            className="
              h-10
              w-full
              rounded-lg
              border
              border-slate-200
              bg-white
              pl-10
              pr-4
              text-sm
              text-slate-700
              placeholder-slate-400
              outline-none
              transition
              focus:border-[#147db5]
              focus:ring-2
              focus:ring-[#147db5]/10
            "
          />
        </div>

        {/* ADVANCED FILTER BUTTON */}
        {(() => {
          const activeCount = Object.entries(filters).filter(
            ([key, val]) => key !== "search" && val && val !== "all"
          ).length;

          return (
            <button
              type="button"
              onClick={onOpenDrawer}
              className={`
                flex
                h-10
                shrink-0
                items-center
                justify-center
                gap-2
                rounded-lg
                border
                px-4
                text-sm
                font-medium
                transition
                ${activeCount > 0 
                  ? "border-[#147db5] bg-blue-50/50 text-[#147db5]" 
                  : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900"}
              `}
            >
              <SlidersHorizontal
                size={16}
                strokeWidth={1.8}
              />

              <span>Filters</span>

              {activeCount > 0 && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#147db5] text-[10px] font-bold text-white">
                  {activeCount}
                </span>
              )}
            </button>
          );
        })()}
      </div>
    </div>
  );
};

export default EmploymentFilters;